<script setup lang="ts">
import styles from '@/assets/sass/components/search-menu.module.scss';
import CompanyFilter from '@/components/CompanyFilter.vue';
import DateFilter from '@/components/DateFilter.vue';
import DestinationFilter from '@/components/DestinationFilter.vue';
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const selectedToggle = ref<string | null>(null);

const toggleOptions = [
    { id: 'flight-cruises', label: 's letenkou', pageName: 'mainPage' },
    { id: 'delegate-cruises', label: 's delegátem', pageName: 'cruisesDelegateListPage' },
    { id: 'luxury-cruises', label: 'Luxusní plavby', pageName: 'cruisesListPageLuxury' },
    { id: 'promo-cruises', label: 'Akční plavby', pageName: 'cruisesListPagePromo' }
];

/**
 * Selects a toggle. If the same toggle is clicked again, it deselects it.
 * @param toggleId The ID of the toggle being clicked.
 */
function selectToggle(toggleId: string) {
    if (selectedToggle.value === toggleId) {
        selectedToggle.value = null; // Deselect if clicked again
    } else {
        selectedToggle.value = toggleId; // Select the new toggle
    }
}


// A computed property to determine the correct route for the RouterLink.
const destinationRoute = computed(() => {
    const defaultPageName = 'cruisesListPage';
    let targetPageName = defaultPageName;

    // If a toggle is selected, find its corresponding page name.
    if (selectedToggle.value) {
        const selectedOption = toggleOptions.find(opt => opt.id === selectedToggle.value);
        if (selectedOption) {
            targetPageName = selectedOption.pageName;
        }
    }

    // Return the route object, preserving the current query.
    return {
        name: targetPageName,
        query: route.query,
    };
});


</script>
<template>
    <div :class="styles.container">
        <div :class="styles.filters">
            <div :class="styles.filter">
                <DestinationFilter />
            </div>
            <div :class="styles.filter">
                <DateFilter />
            </div>
            <div :class="styles.filter">
                posádka
            </div>
            <div :class="styles.filter">
                <CompanyFilter />
            </div>
            <RouterLink :to="destinationRoute" :class="styles.search">
                vyhledat zájezdy
            </RouterLink>
        </div>
        <div :class="styles.toggles">
            <div :class="styles.types">
                <div v-for="toggle in toggleOptions" :key="toggle.id"
                    :class="[styles.type, { [styles.selected]: selectedToggle === toggle.id }]"
                    @click="selectToggle(toggle.id)">
                    {{ toggle.label }}
                </div>
            </div>
            <div :class="styles.advanced">
                Pokročilé vyhledávání
            </div>
        </div>
    </div>
</template>
